import { TextFieldWithHints } from 'common/components/Inputs/TextFieldWithHints/TextFieldWithHints';
import { WritableAtom } from 'jotai';
import { useTranslation } from 'react-i18next';
import { useCustomFieldFilter } from './hooks/useCustomFieldFilter';
import { useCustomFieldHints } from './hooks/useCustomFieldHints';
import { CustomFields } from 'src/simInventory/models/SimProfile.model';
import { customFieldsHintsAtom } from 'src/atoms/hints/sim';

type CustomFieldTextFieldProps = {
  id: number;
  name: string;
  customFieldsFilterAtom: WritableAtom<CustomFields, [CustomFields], void>;
  customFieldsHintsAtom: typeof customFieldsHintsAtom;
};

export const CustomFieldTextField = ({
  id,
  name,
  customFieldsFilterAtom,
  customFieldsHintsAtom,
}: CustomFieldTextFieldProps) => {
  const { t } = useTranslation();

  const [customFieldFilter, setCustomFieldFilter] = useCustomFieldFilter(
    id,
    customFieldsFilterAtom,
  );

  const [customFieldHints, removeCustomField] = useCustomFieldHints(id, customFieldsHintsAtom);

  return (
    <TextFieldWithHints
      data-testid={`customField-text-${id}`}
      placeholder={`${t('simInventory.search')} ${name}`}
      value={customFieldFilter}
      onChange={(value) => {
        setCustomFieldFilter(value || '');
      }}
      hints={customFieldHints ?? []}
      onRemoveHint={(hint: string) => {
        removeCustomField(hint);
      }}
    />
  );
};
